import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IEvent } from "../eventModel";

export const getAllEvents = createAsyncThunk(
  "Events/FindAllEvents",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Events/FindAllEvents`,
        {},
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Evnets:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createEvents = createAsyncThunk(
  "Events/InsertEvents",
  async (EventData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Events/InsertEvents`,
        EventData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Events:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateEvents = createAsyncThunk(
  "Events/UpdateEvents",
  async (EventData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Events/UpdateEvents`,
        EventData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Event:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteEvents = createAsyncThunk(
  "Events/DeleteEvents",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Events/DeleteEvents`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Event :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getEventsByID = createAsyncThunk(
  "Events/FindByIDEvents",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Events/FindByIDEvents`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result?.Title,
        URL: result?.URL,
        Tagline: result?.Tagline,
        Capacity: result?.Capacity,
        RomanticSettings: result?.RomanticSettings,
        Availability: result?.Availability,
        GuestCapacity: result?.GuestCapacity,
        CustomPackages: result?. CustomPackages,
        ShortDescription: result?.ShortDescription || "",
        LongDescription: result?.LongDescription || "",
        PackageHighlights: result?.PackageHighlights || "",
        Inclusion: result?.Inclusion || "",
        Exclusion: result?.Exclusion || "",
        MetaTitle: result?.MetaTitle,
        MetaDescription: result?.MetaDescription,
        MetaKeywords: result?.MetaKeywords,
        MainImage: result?.MainImage,
        BannerImage: result?.BannerImage,
        ImageGallery: result?.ImageGallery,
        EventInnerimage: result?.EventInnerimage || [],
        IsActive: result.IsActive ? 1 : 2,
      } as IEvent;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Event :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveEvents = createAsyncThunk(
  "Events/FindAllActiveEvents",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Events/FindAllActiveEvents`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Active Events:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactiveEvents = createAsyncThunk(
  "Events/ActiveInActiveEvents",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Events/ActiveInActiveEvents`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Events :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// IMAGE UPLOAD
export const EventsImageUpload = createAsyncThunk(
  "Events/EventsImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Events/EventsImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload events Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteEventsImage = createAsyncThunk(
  "Events/DeleteWeddingGalleryImage",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Events/DeleteWeddingGalleryImage`,
        { ID: ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Events image:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
